import React from 'react';
import { Typography } from 'src/components/PulseUI';

const NewTablePrimaryHeader = ({ title }) => {
  return (
    <div className="flex h-auto items-center gap-4 self-stretch">
      <div className="flex flex-col items-start flex-1">
        <div className="flex items-center gap-2">
          <Typography
            variant="h4"
            className="text-[#171A1C] font-semibold leading-[155%]"
          >
            All Affiliated -{' '}
            <Typography
              variant="h4"
              className="text-[#00A783] font-semibold leading-[155%]"
            >
              {title}
            </Typography>
          </Typography>
        </div>
        <Typography
          variant="caption"
          className="text-[#9FA6AD] leading-[144%]"
        >
          All providers practicing or with admitting rights at this location
        </Typography>
      </div>
    </div>
  );
};

export default NewTablePrimaryHeader;
